import React, { useContext, useEffect, useRef, useState } from 'react';
import { PlusOutlined, CloseCircleOutlined, CloseOutlined } from "@ant-design/icons";
import { Button, Checkbox, Form, Input, Popconfirm, Row, Select, Space, Table, Typography } from 'antd';
import ProductData from "../../../../config/data/casaProducts.json"
import { useForm } from 'antd/es/form/Form';
import TextArea from 'antd/es/input/TextArea';
import FormAddCodeValue from './FormAddCodeValue';
const EditableContext = React.createContext(null);

const { Text, Title, Paragraph } = Typography;

const EditableRow = ({ index, ...props }) => {
    const [form] = Form.useForm();
    return (
        <Form form={form} component={false}>
            <EditableContext.Provider value={form}>
                <tr {...props} />
            </EditableContext.Provider>
        </Form>
    );
};



const EditableCell = ({
    title,
    editable,
    children,
    dataIndex,
    record,
    handleSave,
    ...restProps
}) => {
    const [editing, setEditing] = useState(false);
    const inputRef = useRef(null);
    const form = useContext(EditableContext);
    useEffect(() => {
        if (editing) {
            inputRef.current.focus();
        }
    }, [editing]);

    const toggleEdit = () => {
        setEditing(!editing);
        form.setFieldsValue({
            [dataIndex]: record[dataIndex],
        });
    };
    const save = async () => {
        try {
            const values = await form.validateFields();
            toggleEdit();
            handleSave({
                ...record,
                ...values,
            });
        } catch (errInfo) {
            console.log('Save failed:', errInfo);
        }
    };
    let childNode = children;
    if (editable) {
        childNode = editing ? (
            <Form.Item
                style={{
                    margin: 0,
                }}
                name={dataIndex}
                rules={[
                    {
                        required: true,
                        message: `${title} is required.`,
                    },
                ]}
            >
                <Input ref={inputRef} onPressEnter={save} onBlur={save} />
            </Form.Item>
        ) : (
            <div
                className="editable-cell-value-wrap"
                style={{
                    paddingRight: 24,
                }}
                onClick={toggleEdit}
            >
                {children}
            </div>
        );
    }
    return <td {...restProps}>{childNode}</td>;
};



const TableCodeDefinition = ({ disabled, setDisabled, formData, form, dataSource, setDataSource }) => {



    const handleDelete = (key) => {
        const newData = dataSource.filter((item) => item.key !== key);
        setDataSource(newData);
    };

    const defaultColumns = [
        {
            title: "Name",
            dataIndex: "name",
            // editable: true,
        },
        {
            title: "Description",
            dataIndex: "desc",
            // editable: true,
        },
        {
            title: "Position",
            dataIndex: "position",
            // editable: true,
        },
        {
            title: "Active",
            dataIndex: "active",
            // editable: true,
        },
        {
            title: 'Actions',
            dataIndex: 'actions',
            render: (_, record) =>
                dataSource.length >= 1 ? (
                    <Popconfirm
                        title="Sure to delete?"
                        onConfirm={() => handleDelete(record.key)}
                        okText="OK"
                        cancelText="Cancel"
                        okButtonProps={{
                            style: {
                                backgroundColor: '#92428B',
                                color: 'white',
                                height: "15%",
                                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)"
                            }
                        }}
                        cancelButtonProps={{
                            style: {
                                height: "15%",
                                backgroundColor: "white",
                                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)"
                            }
                        }}
                    >
                        <CloseOutlined style={{ color: "#92428B", fontSize: "15px", fontWeight: "bolder" }} />
                    </Popconfirm>
                ) : null,
        },
    ];



    const handleSave = (row) => {
        const newData = [...dataSource];
        const index = newData.findIndex((item) => row.key === item.key);
        const item = newData[index];
        newData.splice(index, 1, {
            ...item,
            ...row,
        });
        setDataSource(newData);
    };

    const components = {
        body: {
            row: EditableRow,
            cell: EditableCell,
        },
    };

    const columns = defaultColumns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record) => ({
                record,
                editable: col.editable,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave,
            }),
        };
    });

    return (
        <div>
            <div hidden={disabled}>
                <Table
                    components={components}
                    rowClassName={() => 'editable-row'}
                    // bordered
                    dataSource={dataSource}
                    columns={columns}
                />
            </div>
        </div>
    );
};
export default TableCodeDefinition;


